const SKU = {
    list: () => "store/sku",
    getById: (id:string) => `store/sku/${id}`,
}

export default SKU